import { render, staticRenderFns } from "./FirstDiagram.vue?vue&type=template&id=0235b670&scoped=true&"
import script from "./FirstDiagram.vue?vue&type=script&lang=js&"
export * from "./FirstDiagram.vue?vue&type=script&lang=js&"
import style0 from "./FirstDiagram.vue?vue&type=style&index=0&id=0235b670&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0235b670",
  null
  
)

export default component.exports